// extracted by mini-css-extract-plugin
export default {"root":"companyBoxList_root__jY7mB","pagination":"companyBoxList_pagination__DzfnB"};